import { createStore } from 'redux'

function sessionReducer(state, action)
{
  switch (action.type)
  {
    case 'LOGGED':
      return {
        'loggedIn': true,
      }
    case 'UNLOGGED':
      return {
        'loggedIn': false,
      }
    default:
      return {
        'loggedIn': false,
      }
  }
}

let sessionStore = createStore(sessionReducer)

export default sessionStore
